var path = 'app/epx/epx.html';
var html = "<section id=\"epx\" class=\"section-cont\">\n\t<div ui-view class=\"page-content\"></div>\n</section>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/epx/epx.html
// module id = ./app/epx/epx.html
// module chunks = 0